module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9xdyG"))).then(() => parcelRequire('dJXJK'));